// call-dispositions.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CallDisposition } from '../profile/company/settings/call-disposition-modal/call-disposition-modal.component';

@Injectable({
  providedIn: 'root'
})
export class CallDispositionsService {
  private apiUrl = `${environment.apiUrl}/call-dispositions`;

  constructor(private http: HttpClient) { }

  getCallDispositions(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  getCallDisposition(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  createCallDisposition(disposition: CallDisposition): Observable<any> {
    return this.http.post<any>(this.apiUrl, disposition);
  }

  updateCallDisposition(id: number, disposition: CallDisposition): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id}`, disposition);
  }

  deleteCallDisposition(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }

  postDisposition(callId: any, dto: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/calls/${callId}/disposition`,
      dto,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  // In call-disposition.service.ts
updateDispositionSequencesBatch(updates: { id: number; sequence: number }[]): Observable<any> {
  return this.http.patch(`${this.apiUrl}/sequences/batch`, updates);
}
}